import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/atoms/PlatformLoader/PlatformLoader.tsx");
